import { useState, useEffect, useCallback, useMemo } from "react";
import { SimpleGrid, FormLabel } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Loading from "../../../Component/Loading/loading";
import apiService from "../../../Method/Report/Report_Service";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../../../assets/Table/TableTheme";
import { t } from "i18next";
import { useDataContext } from "./../../../DataProvider";
import TableWidget from "../../../Component/Table/TableWidget";

const buildColumns = () => [
  {
    name: "WEEKDAY_NAME",
    label: t("DAY_WEEK"),
    options: { filter: false, sort: false },
  },
  {
    name: "TOTAL_ORDERS",
    label: t("TOTAL_ORDERS"),
    options: {
      filter: false, sort: false, customBodyRender: (value) => {
        return value ? value.toLocaleString() : "0";
      },
    },
  },

  {
    name: "TOTAL_SELL",
    label: t("TOTAL_SALES"),
    options: {
      filter: false, sort: false, customBodyRender: (value) => {
        return value ? value.toLocaleString() : "0";
      },
    },

  },
];

function App() {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const { trigger } = useDataContext();
  const [searchText, setSearchText] = useState("");


  const columns = useMemo(() => buildColumns(t), [t]);
  const [searchColumns, setSearchColumns] = useState(() =>
    columns.filter((c) => c.options?.search !== false).map((c) => c.name)
  );
  useEffect(() => {
    setSearchColumns(columns.filter((c) => c.options?.search !== false).map((c) => c.name));
  }, [columns]);

  const fetchData = useCallback(async () => {

    setLoading(true);
    const { success, data, error } = await apiService.search("GET_WEEK_DAY_REPORT_SALES", page + 1, rowsPerPage);

    if (success && data) {
      setLoading(false);
      setData(data);
      setError("")
      setTotalCount(data.TOTAL_COUNT || 0);

    } else {
      setError(error.response.data.message);
      setLoading(false);
    }

  }, [page, rowsPerPage]);

  useEffect(() => {
    fetchData()
  }, [trigger, fetchData]);


  const filteredData = (data?.DETAILS || []).filter((row) => {
    const q = (searchText || "").toLowerCase().trim();
    if (!q) return true;
    return searchColumns.some((name) =>
      row?.[name]?.toString().toLowerCase().includes(q)
    );
  });

  return (
    <ThemeProvider theme={theme}>

      {error && <p className="error-message">{error}</p>}
      {isLoading && <Loading />}
      <div>
        {!isLoading && (
          <div style={{ width: "100%", overflowX: "auto", marginTop: "10px" }}>
            <SimpleGrid
              className="Total_Header"

              columns={{ base: 1, md: 2 }}
            >
              <div>
                <div>
                  <FormLabel className="Total_Header_Right">
                    {t("TOTAL_ORDERS")}
                  </FormLabel>
                  <FormLabel
                    className="Total_Header_Value"
                  >
                    {data.ALL_TOTAL_ORDERS ? data.ALL_TOTAL_ORDERS.toLocaleString() : "0"}
                  </FormLabel>
                </div>
              </div>

              <div>
                <FormLabel className="Total_Header_Left" >
                  {t("TOTAL_SALES")}
                </FormLabel>
                <FormLabel
                  className="Total_Header_Value"

                >
                  {data.ALL_TOTAL_SELL ? data.ALL_TOTAL_SELL.toLocaleString() : "0"}
                </FormLabel>
              </div>
            </SimpleGrid>
            <TableWidget
              title={t("SALES_REPORT_DAY_WEEK")}

              data={filteredData}
              onSearchChange={setSearchText}
              columns={columns}
              totalCount={totalCount}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={setPage}
              onRowsPerPageChange={setRowsPerPage}
              searchColumns={searchColumns}
              setSearchColumns={setSearchColumns}
            />


          </div>
        )}
      </div>
    </ThemeProvider >
  );
}

export default App;
